import React, { FC } from 'react';
import { Helmet } from 'react-helmet';

import { MikMakProps } from './models';

const MikMak: FC<MikMakProps> = ({ appId }) => (
  <Helmet>
    <script type="text/javascript">
      {`(function(e,d){try{var a=window.swnDataLayer=window.swnDataLayer||{};a.appId=e||a.appId,a.eventBuffer=a.eventBuffer||[],a.loadBuffer=a.loadBuffer||[],a.push=a.push||function(e){a.eventBuffer.push(e)},a.load=a.load||function(e){a.loadBuffer.push(e)},a.dnt=a.dnt!=null?a.dnt:d;var t=document.getElementsByTagName("script")[0],n=document.createElement("script");n.async=!0,n.src="//wtb-tag.mikmak.ai/scripts/"+a.appId+"/tag.min.js",t.parentNode.insertBefore(n,t)}catch(e){console.log(e)}}("${appId}", false));`}
    </script>
  </Helmet>
);

export default MikMak;
